// @mui material components
import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Button,
  Grid,
  Rating,
  ListItem,
  ListItemText,
  Typography,
  Box,
  IconButton,
  Paper,
} from "@mui/material";

import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "../../axios";
// import DataTable from "theme/Tables/DataTable";
import usePageTitle from "../pageTitle";
import { PieChart } from "@mui/x-charts";
import CheckoutFooter from "../components/footer";
import AppConfig from "../../appConfig";
import GoogleMapReact from "google-map-react";

function PSAInsightsPage() {
  const pageTitle = "Product Sampling - Insights";
  usePageTitle(pageTitle);
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [insights, setInsights] = useState(null);
  const [campaign, setCampaign] = useState(null);

  const [mapZoom, setMapZoom] = useState(13);

  function getPieChartData(data) {
    const datas = [
      { label: "Yes", value: data.yes },
      { label: "Maybe", value: data.maybe },
      { label: "No", value: data.no },
    ];

    return datas;
  }

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`campaign/window/psa/report/${ref}`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setCampaign(result.data.data.campaign);
            setInsights(result.data.data.insights);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  return (
    <Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Box
        sx={{ width: { xs: "95%", md: "80%", lg: "80%" }, margin: "0px auto" }}
      >
        {pageLoaded && (
          <Box mb={5}>
            <Box>
              <Paper elevation={0}>
                <Box p={2} align="center">
                  <Box mt={0} display="flex" justifyContent="space-between">
                    <Box>
                      <Typography variant="h6" fontWeight={400}>
                        <Icon color="info">bar_chart</Icon>
                      </Typography>
                    </Box>
                    <Box>
                      <Button
                        onClick={() => {
                          setRefreshPage(!refreshPage);
                        }}
                      >
                        <Icon>replay</Icon>
                      </Button>
                      <Button
                        onClick={() => {
                          // toPDF();
                          window.print();
                        }}
                      >
                        <Icon>print</Icon>
                      </Button>
                    </Box>
                  </Box>
                  <Box mt={2}>
                    <img
                      src={`${AppConfig.api_media_url}${campaign.account.logo}`}
                      alt="img"
                      style={{ maxWidth: 200, maxHeight: "80%" }}
                    />
                  </Box>
                  <Box mt={1}>
                    <Typography variant="subtitle1" fontWeight={500}>
                      {campaign.account.title}
                    </Typography>
                  </Box>
                  <Box mt={1}>
                    <Typography variant="caption" fontWeight={350}>
                      {campaign.title}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Box>
            <Box mt={2}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={3} lg={3}>
                  <Box>
                    <Card>
                      <Box p={2} align="center">
                        <Typography>
                          <Icon>person_alt</Icon>
                        </Typography>
                        <Typography fontSize={24}>
                          {insights.sampled}
                        </Typography>
                        <Typography variant="body2">
                          Customers
                          <br />
                          Sampled
                        </Typography>
                      </Box>
                    </Card>
                  </Box>
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                  <Box>
                    <Card>
                      <Box p={2} align="center">
                        <Typography>
                          <Icon>rate_review</Icon>
                        </Typography>
                        <Typography fontSize={24}>
                          {insights.feedbacks}
                        </Typography>
                        <Typography variant="body2">
                          Feedback
                          <br />
                          Received
                        </Typography>
                      </Box>
                    </Card>
                  </Box>
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                  <Box>
                    <Card>
                      <Box p={2} align="center">
                        <Typography>
                          <Icon>inventory</Icon>
                        </Typography>
                        <Typography fontSize={24}>
                          {insights.totalQty}
                        </Typography>
                        <Typography variant="body2">
                          Quantity
                          <br />
                          Distributed
                        </Typography>
                      </Box>
                    </Card>
                  </Box>
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                  <Box>
                    <Card>
                      <Box p={2} align="center">
                        <Typography fontSize={21}>{campaign.currency}</Typography>
                        <Typography fontSize={24}>
                          {(insights.totalVol / 100).toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </Typography>
                        <Typography variant="body2">
                          Volume
                          <br />
                          Distributed
                        </Typography>
                      </Box>
                    </Card>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box mt={5}>
              {insights.products.map((product) => (
                <Box>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={4} lg={4}>
                      <Box>
                        <Card>
                          <Box p={1}>
                            <Box mb={1}>
                              <ListItem>
                                <ListItemText
                                  primary={product.name}
                                  secondary={`Sampled: ${product.costs.sampled}`}
                                />
                              </ListItem>
                            </Box>
                          </Box>
                        </Card>
                        <Box mt={3}>
                          <Card>
                            <Box p={2}>
                              <Typography variant="body2" fontSize={13} mb={1}>
                                Rating (AVG)
                              </Typography>
                              <Rating value={product.rating} readOnly />
                            </Box>
                          </Card>
                        </Box>
                      </Box>
                      <Box mt={3}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={6} lg={6}>
                            <Card>
                              <Box p={1} align="center">
                                <Typography>
                                  <Icon>inventory</Icon>
                                </Typography>
                                <Typography fontSize={18}>
                                  {product.costs.quantity.toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Typography>
                                <Typography variant="body2" fontSize={13}>
                                  Quantity
                                </Typography>
                              </Box>
                            </Card>
                          </Grid>
                          <Grid item xs={12} md={6} lg={6}>
                            <Card>
                              <Box p={1} align="center">
                                <Typography fontSize={21}>
                                  {campaign.currency}
                                </Typography>
                                <Typography fontSize={18}>
                                  {(product.costs.volume / 100).toLocaleString(
                                    "en",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  )}
                                </Typography>
                                <Typography variant="body2" fontSize={13}>
                                  Spend
                                </Typography>
                              </Box>
                            </Card>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={8} lg={8}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6} lg={6}>
                          <Box sx={{ height: "100%" }}>
                            <Paper>
                              <Box p={2}>
                                <Typography>Buy Sentiment (%)</Typography>
                                <Box mt={2}>
                                  <PieChart
                                    series={[
                                      {
                                        data: getPieChartData(
                                          product.buy.percentages,
                                        ),
                                      },
                                    ]}
                                    paddingAngle={10}
                                    height={200}
                                  />
                                </Box>
                              </Box>
                            </Paper>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                          <Box sx={{ height: "100%" }}>
                            <Paper>
                              <Box p={2}>
                                <Typography>Recommend Sentiment (%)</Typography>
                                <Box mt={2}>
                                  <PieChart
                                    series={[
                                      {
                                        data: getPieChartData(
                                          product.recommend.percentages,
                                        ),
                                      },
                                    ]}
                                    paddingAngle={10}
                                    height={200}
                                  />
                                </Box>
                              </Box>
                            </Paper>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              ))}
            </Box>
            {insights.spreadData.length > 0 && (
              <Box mt={5}>
                <Card>
                  <Box p={3}>
                    <Box mb={3} display="flex" justifyContent="space-between">
                      <Box>
                        <Typography variant="h6" fontWeight="bold">
                          Location HeatMap
                        </Typography>
                      </Box>
                      <Box>
                        <IconButton
                          size="small"
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            let pZoom = mapZoom;
                            pZoom -= 1;
                            pZoom = pZoom < 4 ? 4 : pZoom;
                            setMapZoom(pZoom);
                          }}
                        >
                          <Icon>remove</Icon>
                        </IconButton>
                        &nbsp;
                        <Typography
                          variant="caption"
                          fontSize={10}
                          fontWeight="light"
                        >
                          Zoom
                        </Typography>
                        &nbsp;
                        <IconButton
                          size="small"
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            let pZoom = mapZoom;
                            pZoom += 1;
                            pZoom = pZoom > 20 ? 20 : pZoom;
                            setMapZoom(pZoom);
                          }}
                        >
                          <Icon>add</Icon>
                        </IconButton>
                      </Box>
                    </Box>
                    <Box sx={{ height: "65vh", width: "100%" }}>
                      <GoogleMapReact
                        bootstrapURLKeys={{ key: AppConfig.google_map_key }}
                        defaultCenter={{
                          lat: insights.spreadData[0].latitude,
                          lng: insights.spreadData[0].longitude,
                        }}
                        defaultZoom={mapZoom}
                        zoom={mapZoom}
                      >
                        {insights.spreadData.map((loc) => (
                          <Box lat={loc.latitude} lng={loc.longitude}>
                            <Typography fontSize={24}>
                              <Icon color="error">location_on</Icon>
                            </Typography>
                          </Box>
                        ))}
                      </GoogleMapReact>
                    </Box>
                  </Box>
                </Card>
              </Box>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default PSAInsightsPage;
